<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div
      id="report-top-sell"
      class="wrapper wrapper-content animated fadeInRight"
    >
      <div class="row">
        <bita-ibox class="col-lg-6 p-1" :is-loading="isLoadingTopSell">
          <div slot="body">
            <search-component @search="searchTopSell" />
            <h4>پر فروش ترین محصول</h4>
            <bita-grid
              ref="topSellGrid"
              :columns="topSellColumns"
              :read-data="loadDataTopSell"
              :page-size="10"
              :current-page="1"
              :has-row-number="true"
              :column-menu="grid.columnMenu"
              :grid-server-side="true"
              :server-paging="false"
              :schema-data="'data'"
              :pageable="false"
            />
            <!-- <table class="table table-hover margin bottom">
              <thead>
                <tr>
                  <th style="width: 1%" class="text-center">ردیف</th>
                  <th class="text-center">نام محصول</th>
                  <th class="text-center">تعداد فروش</th>
                  <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, index) in topSell" :key="report.id">
                  <td class="text-center">{{ ++index }}</td>
                  <td class="text-center">{{ report.product.name }}</td>
                  <td class="text-center">{{ report.count }}</td>
                  <td class="text-center">
                    {{ $thousandSeprator(report.total_payable) }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </bita-ibox>

        <bita-ibox class="col-lg-6 p-1" :is-loading="isLoadingTopUser">
          <div slot="body">
            <search-component @search="searchTopSellUser" />
            <h4>کاربرانی که بیشترین خرید را داشته اند</h4>
            <bita-grid
              ref="topSellGridUser"
              :columns="topSellUserColumns"
              :read-data="loadDataTopSellUser"
              :page-size="10"
              :current-page="1"
              :has-row-number="true"
              :column-menu="grid.columnMenu"
              :grid-server-side="true"
              :server-paging="false"
              :schema-data="'data'"
              :pageable="false"
            />
            <!-- <table class="table table-hover margin bottom">
              <thead>
                <tr>
                  <th style="width: 1%" class="text-center">ردیف</th>
                  <th class="text-center">نام کاربر</th>
                  <th class="text-center">تعداد خرید</th>
                  <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, index) in topSellUser" :key="report.id">
                  <td class="text-center">{{ ++index }}</td>
                  <td class="text-center">
                    {{ report.name }} {{ report.family }}
                  </td>
                  <td class="text-center">{{ report.count }}</td>
                  <td class="text-center">
                    {{ $thousandSeprator(report.payable_price) }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </bita-ibox>

        <bita-ibox class="col-lg-6 p-1" :is-loading="isLoadingTopProvince">
          <div slot="body">
            <search-component @search="searchTopSellProvince" />
            <h4>پر فروش ترین استان ها</h4>
            <bita-grid
              ref="topSellGridProvince"
              :columns="topSellProvinceColumns"
              :read-data="loadDataTopSellProvince"
              :page-size="10"
              :current-page="1"
              :has-row-number="true"
              :column-menu="grid.columnMenu"
              :grid-server-side="true"
              :server-paging="false"
              :schema-data="'data'"
              :pageable="false"
            />
            <!-- <table class="table table-hover margin bottom">
              <thead>
                <tr>
                  <th style="width: 1%" class="text-center">ردیف</th>
                  <th class="text-center">استان</th>
                  <th class="text-center">تعداد فروش</th>
                  <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, index) in topSellProvince" :key="report.id">
                  <td class="text-center">{{ ++index }}</td>
                  <td class="text-center">{{ report.province }}</td>
                  <td class="text-center">{{ report.count }}</td>
                  <td class="text-center">
                    {{ $thousandSeprator(report.payable_price) }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </bita-ibox>

        <bita-ibox class="col-lg-6 p-1" :is-loading="isLoadingTopCity">
          <div slot="body">
            <search-component @search="searchTopSellCity" />
            <h4>پر فروش ترین شهر ها</h4>
            <bita-grid
              ref="topSellGridCity"
              :columns="topSellCityColumns"
              :read-data="loadDataTopSellCity"
              :page-size="10"
              :current-page="1"
              :has-row-number="true"
              :column-menu="grid.columnMenu"
              :grid-server-side="true"
              :server-paging="false"
              :schema-data="'data'"
              :pageable="false"
            />
            <!-- <table class="table table-hover margin bottom">
              <thead>
                <tr>
                  <th style="width: 1%" class="text-center">ردیف</th>
                  <th class="text-center">شهر</th>
                  <th class="text-center">تعداد فروش</th>
                  <th class="text-center">{{ $currencyLabel("مبلغ") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, index) in topSellCity" :key="report.id">
                  <td class="text-center">{{ ++index }}</td>
                  <td class="text-center">{{ report.city }}</td>
                  <td class="text-center">{{ report.count }}</td>
                  <td class="text-center">
                    {{ $thousandSeprator(report.payable_price) }}
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </bita-ibox>
      </div>
    </div>
  </div>
</template>
<script>
import { reportApi } from "@/api/apiManagement";
import Tools from "../../../components/Tools.vue";
import SearchComponent from "./searchComponent.vue";

export default {
  components: { Tools, SearchComponent },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "گزارش پرفروش ترین محصولات",
          link: "/shop/reports",
          active: true,
        },
      ],
      isLoadingTopSell: false,
      isLoadingTopUser: false,
      isLoadingTopProvince: false,
      isLoadingTopCity: false,
      topSell: [],
      topSellFilter: {},
      topSellUser: [],
      topSellUser: {},
      topSellProvince: [],
      topSellCity: [],
    };
  },
  computed: {
    topSellColumns() {
      return [
        {
          field: "product_name",
          title: "نام محصول",
          template: (e) => (e.product.name ? e.product.name : " - "),
          filterable: true
        },
        {
          field: "count",
          title: "تعداد فروش",
          template: (e) => (e.count ? e.count : " - "),
          filterable: true
        },
        {
          field: "total",
          title: this.$currencyLabel("مبلغ"),
          template: (e) =>
            e.total ? this.$thousandSeprator(e.total_payable) : " - ",
        },
      ];
    },
    topSellUserColumns() {
      return [
        {
          field: "family",
          title: "نام کاربر",
          template: (e) => (e.family ? e.family : " - "),
          filterable: true
        },
        {
          field: "count",
          title: "تعداد خرید",
          template: (e) => (e.count ? e.count : " - "),
          filterable: true
        },
        {
          field: "payable_price",
          title: this.$currencyLabel("مبلغ"),
          template: (e) =>
            e.payable_price ? this.$thousandSeprator(e.payable_price) : " - ",
        },
      ];
    },
    topSellProvinceColumns() {
      return [
        {
          field: "province",
          title: "استان",
          template: (e) => (e.province ? e.province : " - "),
          filterable: true
        },
        {
          field: "count",
          title: "تعداد فروش",
          template: (e) => (e.count ? e.count : " - "),
          filterable: true
        },
        {
          field: "payable_price",
          title: this.$currencyLabel("مبلغ"),
          template: (e) =>
            e.payable_price ? this.$thousandSeprator(e.payable_price) : " - ",
        },
      ];
    },
    topSellCityColumns() {
      return [
        {
          field: "city",
          title: "شهر",
          template: (e) => (e.city ? e.city : " - "),
          filterable: true
        },
        {
          field: "count",
          title: "تعداد فروش",
          template: (e) => (e.count ? e.count : " - "),
          filterable: true
        },
        {
          field: "payable_price",
          title: this.$currencyLabel("مبلغ"),
          template: (e) =>
            e.payable_price ? this.$thousandSeprator(e.payable_price) : " - ",
        },
      ];
    }
  },
  mounted() {
    // this.loadDataTopSell();
    // this.loadDataTopSellUser();
    // this.loadDataTopSellProvince();
    // this.loadDataTopSellCity();
  },
  methods: {
    searchTopSell(filter) {
      this.topSellFilter = filter
      this.$refs.topSellGrid.loadDataSource();
    },
    searchTopSellUser(filter) {
      this.topSellFilterUser = filter
      this.$refs.topSellGridUser.loadDataSource();
    },
    searchTopSellProvince(filter) {
      this.topSellFilterProvince = filter
      this.$refs.topSellGridProvince.loadDataSource();
    },
    searchTopSellCity(filter) {
      this.topSellFilterCity = filter
      this.$refs.topSellGridCity.loadDataSource();
    },
    loadDataTopSell(e) {
      this.isLoadingTopSell = true;
      reportApi
        .getTopSell(this.topSellFilter)
        .then((res) => {
          e.success(res);
        })
        .catch(() => {
          this.topSell = [];
        })
        .finally(() => {
          this.isLoadingTopSell = false;
        });
    },
    loadDataTopSellUser(e) {
      this.isLoadingTopUser = true;

      reportApi
        .getTopSellUser(this.topSellFilterUser)
        .then((res) => {
          e.success(res);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingTopUser = false;
        });
    },
    loadDataTopSellProvince(e) {
      this.isLoadingTopProvince = true;

      reportApi
        .getTopSellProvince(this.topSellFilterProvince)
        .then((res) => {
          e.success(res);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingTopProvince = false;
        });
    },
    loadDataTopSellCity(e) {
      this.isLoadingTopCity = true;

      reportApi
        .getTopSellCity(this.topSellFilterCity)
        .then((res) => {
          e.success(res);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingTopCity = false;
        });
    },
  },
};
</script>
<style scoped>
a.margin-top {
  margin-top: 27px;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
<style>
#report-top-sell .ibox-content {
  min-height: 472px;
}
</style>
